import { API } from "@/services"

export const SIP_INCOMING_CALL_TEST_ENDPOINTS = {
  create(data={}){
    return API.Axios.error_capture.v1.request({
      url: `sip-incoming-call-test`,
      method: 'POST',
      data,
    })
  },
  dialCallToSpecificExtension(extension_accountcode='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `sip-incoming-call-test/${extension_accountcode}/dial-call`,
      method: 'POST',
      data,
    })
  },
  list(params={}){
    return API.Axios.error_capture.v1.request({
      url: `sip-incoming-call-test`,
      method: 'GET',
      params,
    })
  },
  chart(){
    return API.Axios.error_capture.v1.request({
      url: `sip-incoming-call-test/chart`,
      method: 'GET',
    })
  }
}